import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

// Actions
import {
  updateActiveProfile
} from '../../../actions/activeProfile'

import {
  showModal,
} from '../../../actions/modal'

// Packages
import { Helmet } from 'react-helmet'
import { Elements } from 'react-stripe-elements'

// Components
import Header from '../../../components/Global/Header'
import Footer from '../../../components/Global/Footer'
import PaymentNote from '../../../components/Payment/PaymentNote'
// import PricingSummaryBlock from '../../../components/Pricing/PricingSummaryBlock';
import AccountSettingsNav from '../../../components/UserPortal/AccountSettings/AccountSettingsNav'
import FormContainer from '../../../components/Global/FormContainer'
import CreditCardForm from '../../../components/Forms/CreditCardForm'
import FlashMessage from '../../../components/Global/FlashMessage'
import * as API from "../../../utils/api";

// Utils
import { mathTrunc } from '../../../utils/helpers'

class PaymentInfoSubscribe extends Component {
  state = {
    submissionStatus: '',
    numberOfSports: 0,
    redirectPath: null,
    switchingProfiles: false,
    errorMessage: '',
    taxRate: '0.0',
    oneTimeFee: 0,
    coupon: {},
    activationFee: 5,
  }

  componentDidMount() {
    // Keeping this function for the time being. Client may change pricing model
    // again and this may be necessary:
    // API.getOneTimeFee().then(response => {
    //   if (response.errors || response.error) {
    //     console.log('Error getting One Time Fee')
    //   } else {
    //     this.setState({
    //       oneTimeFee: parseFloat(response.price_in_dollars)
    //     })
    //   }
    // })
    this.initializePaymentInfoSubscribe(this.props)
  }

  componentWillReceiveProps(nextProps) {
    // If activeProfile has not changed, initialize the screen
    if (this.props.activeProfile.username === nextProps.activeProfile.username) {
      this.initializePaymentInfoSubscribe(nextProps)
    } else {
      this.handleProfileSwitch(nextProps)
    }
  }

  validateCoupon = (coupon) =>  {
    const { user } = this.props

    API.getCoupon(user, coupon).then(response => {
      if (response.errors || response.error) {
        this.setState({
          coupon: {
            valid: false
          }
        })
      } else {
        let { coupon } = response
        this.setState({
          coupon: coupon
        })
      }
    })
  }

  handleGetTaxRate = (zipCode) =>  {
    const { user } = this.props

    API.getTaxRate(user, zipCode).then(response => {
      if (response.errors || response.error) {
        this.setState({
          errorMessage: response.errors[0] ? response.errors[0] : 'Error getting tax rate. Please try again.'
        })
      } else {
        this.setState({
          taxRate: response.totalRate
        })
      }
    })
  }

  initializePaymentInfoSubscribe(props) {
    const { activeProfile } = props

    if (activeProfile.subscribed) {
      this.setState({redirectPath: '/settings/payment-info/confirmed'})
    } else {
      this.setNumberOfSports()
    }
  }

  handleProfileSwitch(props) {
    const { activeProfile } = props

    if (activeProfile.subscribed) {
      this.setState({redirectPath: '/settings/payment-info/'})
    } else {
      this.setNumberOfSports()
    }
  }

  setNumberOfSports() {
    const { sport_count } = this.props.accountDetails.payment_info

    this.setState({
      numberOfSports: sport_count ? sport_count : 1
    })
  }

  handleInitialSubmit = (stripeResponse, address) => {
    if (stripeResponse.error) {
      window.scrollTo(0, 0)
      this.setState({
        errorMessage: stripeResponse.error.message
      })
    } else {
      this.updateActiveProfileTrialInfo()
      this.showConfirmationModal(stripeResponse.token.id, address)
    }
  }

  updateActiveProfileTrialInfo() {
    const { activeProfile, user } = this.props;
    let updatedActiveProfile = { ...activeProfile }

    updatedActiveProfile.trial_info.on_trial = false
    this.props.updateActiveProfile(user, activeProfile.username, updatedActiveProfile);
  }

  showConfirmationModal(token, address) {
    const {
      numberOfSports,
      taxRate,
      coupon
    } = this.state

    let modal = {
      modalType: 'stripe-payment-confirmation',
      optionalProps: {
        token: token,
        taxRate: taxRate,
        address: address,
        coupon: coupon,
        numberOfSports: numberOfSports,
        modalLocation: 'dashboard'
      }
    }

    this.props.showModal(modal)
  }

  getAnnualFee(lessOne = false, initialFee = false) {
    const { numberOfSports } = this.state
    if (initialFee) {
      return 199
    }

    return lessOne ? 99 * (numberOfSports - 1) : 99 * parseInt(numberOfSports, 10)
  }

  calculateFirstYear() {
    const { oneTimeFee } = this.state;
    let total = oneTimeFee + this.getAnnualFee(false, true)
    return total
  }

  calculateFirstYearDollars() {
    return mathTrunc(this.state.oneTimeFee) + this.getAnnualFee(false, true)
  }

  getFirstYearCents() {
    let fee = this.state.oneTimeFee.toFixed(2)
    let cents = String(fee).split(".")[1]
    if (cents !== "00") {
      return "." + cents
    }
  }

  getPaymentNote() {
    const {
      numberOfSports,
      redirectPath,
      coupon,
      taxRate,
      oneTimeFee,
      activationFee,
    } = this.state

    return redirectPath
    ? (<Redirect to={{ pathname: redirectPath }}/>)
    : (
      <PaymentNote
        coupon={coupon}
        numberOfSports={numberOfSports}
        taxRate={taxRate}
        oneTimeFee={oneTimeFee}
        activationFee={activationFee}
      />
    )
  }

  renderStripeErrorMessage() {
    const { errorMessage } = this.state
    return errorMessage.length > 0
    ? (
      <FlashMessage optionalClasses='error'>
        {errorMessage}
      </FlashMessage>
    )
    : ''
  }

  render() {
    const { path, appName } = this.props
    const {
      submissionStatus,
      coupon,
    } = this.state

    return (
      <div className="user-portal account-settings payment-info-subscribe">
        <Helmet>
          <title>{appName} | Settings – Update Payment Info</title>
        </Helmet>
        <Header path={ path } />
        <AccountSettingsNav currentTab="payment-info" />
        <div className="inner-wrap">
          <FormContainer
            optionalClassName="payment-info-subscribe-message"
          >
            <p>
              Sign up for a premier subscription to unlock all of Locker Linked's best features!
            </p>
          </FormContainer>
        </div>
        <div className="payment-info-subscribe-content inner-wrap content">
          <FormContainer
            optionalClassName="payment-info-description"
          >
            <header>
              <h4>Premier Plan</h4>
              <h2>Benefits of Premier</h2>
            </header>
            <ul>
              <li>
                Fully customize your player profile.
              </li>
              <li>
                Showcase your highlights, game stats, awards, accomplishments, attended camps, ratings & more
              </li>
              <li>
                Get full access to popular recruiting tips & resources
              </li>
              <li>
                Get full access to our comprehensive resource library featuring:
              </li>
              <ul>
                <li>
                  Recruiting tips
                </li>
                <li>
                  Showcase your highlights, game stats, awards, accomplishments, attended camps, ratings & more.
                </li>
                <li>
                  Get full access to popular recruiting tips & resources.
                </li>
                <li>
                  Get full access to our Coaches Database with 58,000 College Coaches’ contact information.
                </li>
                <li>
                  NCAA resources
                </li>
              </ul>
            </ul>
            <div className="pricing">
              <div className="pricing-annual-price">
                <p className="pricing-annual-price-dollar-amount">
                  ${this.calculateFirstYearDollars()}<sup>{this.getFirstYearCents()}</sup>*
                </p>
                <span className="pricing-annual-price-description">
                  Includes one time setup fee for one sport and the first 6 months of user fees!
                </span>
              </div>
              <ul>
                <li className="pricing-secondary-price">
                  Continue after 6 months for only $10 per month
                </li>
                <li className="pricing-secondary-price">
                  $99 one time setup fee for each additional sport
                </li>
              </ul>
              <span>
                * Plus a one time Activation Fee of $5
              </span>
            </div>
          </FormContainer>
          <FormContainer
            optionalClassName="payment-info-form"
          >
            <header>
              <h4>Get Recruited</h4>
              <h1>Upgrade to Premier</h1>
            </header>
            {this.renderStripeErrorMessage()}
            <Elements>
              <CreditCardForm
                submitText='Submit Payment'
                handleFormSubmit={this.handleInitialSubmit}
                getTaxRate={this.handleGetTaxRate}
                validateCoupon={this.validateCoupon}
                coupon={coupon}
                status={submissionStatus}
                paymentNote={this.getPaymentNote()}
              />
            </Elements>
          </FormContainer>
        </div>
        <Footer appName={ appName } path={ path } />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    accountDetails: state.accountDetails,
    activeProfile: state.activeProfile
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showModal: (modalType) => {
      dispatch(showModal(modalType))
    },
    updateActiveProfile: (user, username, profile) => {
      dispatch(updateActiveProfile(user, username, profile))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentInfoSubscribe)


// Keeping this note in case client changes pricing model again:
// <hr/>
// <div className="payment-note-secondary">
//   <p>
//     * Payment will appear as two charges on your card's statement:
//   </p>
//   <ul>
//     <li>
//       ${this.chargeLineItem(oneTimeFee, true)} - one-time registration fee <span className="sub-text">{this.taxMessage()}</span>
//     </li>
//     <li>
//       ${this.chargeLineItem(this.getAnnualFee())} - annual payment, {numberOfSports} sport{numberOfSports > 1 ? 's' : ''} @ $99/sport <span className="sub-text">{this.taxMessage()}</span>
//     </li>
//   </ul>
// </div>


// taxMessage() {
//   if (this.state.taxRate !== '0.0') {
//     return "(including tax)"
//   } else {
//     return "(plus tax)"
//   }
// }

// chargeLineItem(chargeAmount, oneTimeFee = false) {
//   return this.calculateRateWithTax(this.calculateWithDiscount(chargeAmount, oneTimeFee)).toFixed(2)
// }



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Settings/PaymentInfoSubscribe.js